import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import SignIn from '@/features/auth/sign-in'

export const Route = createFileRoute('/(auth)/sign-in')({
  component: SignIn,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Se Connecter`,
      },
    ],
  }),
})
